import React, { FunctionComponent } from "react"
import s from "./Home.less"
import { useNavigation } from "../../hooks/useNavigation"
import Widget from "./Widget"

const Home: FunctionComponent = () => {
  const menu = useNavigation()
  return (
    <div className={`${s.root} content`}>
      <h1 className="page-header">Dashboard</h1>
      <div className={s.gridView}>
        {menu?.map((item, i) => (
          <Widget key={i} item={item} />
        ))}
      </div>
    </div>
  )
}

export default Home
